export default __webpack_public_path__ + "static/media/hm-gp-img.7b507cff.webp";